/** Search frame chrome. */
export default {
  openResult: "Open {title}",
  searching: "Searching…",
  toolInput: "Tool input",
  noResults: "No results",
} as const;
